/**
 * Slideshow for image or video content entities.
 * e.g. slideshow="[{
 *     assets: {
 *         main: {
 *             src: 'http://a/url/to/somewhere'
 *             attrs: {
 *                 class: 'a classname'
 *             }
 *         }
 *     }
 * }, { ... }]"
 */
angular.module('pitch.app')
.directive('slideshow', function($interval, $sce) {
    "use strict";
    return {
        restrict: 'A',
        transclude: true,
        replace: true,
        scope: {
            'items': '=slideshow',
            'delay': '=',
            'paralaxFactor': '='
        },
        compile: function(element, attrs) {
            attrs.delay = attrs.delay || '5000';
            attrs.paralaxFactor = attrs.paralaxFactor || '5';
        },
        controller: function($scope) {
            var rotate;

            $scope.current = $scope.items[0];

            if ($scope.items.length > 1) {
                //then rotate the items
                var index = 0;

                rotate = $interval(function() {
                    index++;
                    index = index < $scope.items.length ? index : 0;
                    $scope.current = $scope.items[index];
                }, $scope.delay);
            }

            $scope.getVideoUrl = function(video) {
                return $sce.trustAsResourceUrl(video.assets.main.src);
            };

            $scope.$on('$destroy', function() {
                $interval.cancel(rotate);
            });

        },
        template:   '<div class="slideshow [[(current.assets|asset:\'main\').attrs.class]]">' +
                        '<div class="slideshow-item" ng-repeat="item in ::items" ng-init="asset = (item.assets|asset:\'main\')">' +
                            '<div paralax-top="[[::paralaxFactor]]" active="current == item"" class="bg-wrapper" aria-hidden="true">' +
                                '<img ng-if="::item.type == \'image\'"' +
                                    ' ng-show="current == item"' +
                                    ' ng-src="[[::asset.src]]"' +
                                    ' alt="[[::asset.alt]]"' +
                                    ' class="bg fade-in" />' +
                                // '<video autoplay loop="true" muted="true" ng-if="::item.type == \'video\'"' +
                                //     ' ng-show="current == item"' +
                                //     ' ng-src="[[::getVideoUrl(item)]]"' +
                                //     ' alt="[[::asset.alt]]"' +
                                //     ' class="bg fade-in"></video>' +
                            '</div>' +
                        '</div>' +
                        '<div class="body" ng-transclude></div>' +
                    '</div>'
    };
})


;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/slideshow.js